import React, { useEffect, useCallback, useState, useRef } from 'react';
import SearchCondition from './components/search_condition/index';
import SceneMarketingResult from './components/scene_marketing_result/index';
import { useLocation, history } from 'umi';
import CardListML from '@/components/CardListML';
import { useDispatch, useSelector } from 'dva';
import qs from 'qs';
import dayjs from 'dayjs';
import { useIntl } from 'umi';
import { Box } from '@material-ui/core';
import webStorage from '@/utils/storageManager';

export default () => {
  const userAuths = webStorage.get('USER')?.authorities;
  const dispatch = useDispatch();
  const location = useLocation();
  const intl = useIntl();
  const { formatMessage } = intl;
  const searchRef = useRef();
  const [modification, setModification] = useState({});
  const { query, pathname } = location;
  const { title, status, type, pageNum = '1', pageSize = '10', time } = query;

  const fetchCardData = useCallback(() => {
    dispatch({
      type: 'sceneMarketing/getIsCreated',
      payload: {
        values: {},
      },
    });
  }, [dispatch, modification]);

  useEffect(() => {
    fetchCardData();
  }, [fetchCardData]);

  const creatList = useSelector((state) => state.sceneMarketing.creatList);
  const [isSearch, setIsSearch] = useState(false);
  const timestamp = dayjs().format('YYYY-MM-DD HH-mm-ss');

  const marketingData = [
    {
      id: 3,
      cardTitle: formatMessage({ id: 'marketing.scene.n01.lbl01' }),
      cardDesc: [
        formatMessage({ id: 'marketing.scene.n01.lbl02' }),
        formatMessage({ id: 'marketing.scene.n01.lbl03' }),
      ],
      imgUrl: require('@/assets/img/m1.jpg'),
      disabled:
        (creatList &&
          !creatList?.find((item) => item.type === 'FESTIVAL_ACTIVITY')
            ?.created) ||
        !userAuths.includes('MENU_MARKETING_SCENE_FESTIVAL'),
      oid: 'btn_marketing_activity_scene_marketing_list_create_festival_marketing',
    },
    {
      id: 0,
      cardTitle: formatMessage({ id: 'marketing.scene.n02.lbl01' }),
      cardDesc: [
        formatMessage({ id: 'marketing.scene.n02.lbl02' }),
        formatMessage({ id: 'marketing.scene.n02.lbl03' }),
      ],
      imgUrl: require('@/assets/img/m2.jpg'),
      disabled:
        (creatList &&
          !creatList?.find((item) => item.type === 'REGISTRATION_ACTIVITY')
            ?.created) ||
        !userAuths.includes('MENU_MARKETING_SCENE_REGISTRATION'),
      oid: 'btn_marketing_activity_scene_marketing_list_create_festival_marketing',
    },
    {
      id: 1,
      cardTitle: formatMessage({ id: 'marketing.scene.n03.lbl01' }),
      cardDesc: [
        formatMessage({ id: 'marketing.scene.n04.lbl02' }),
        formatMessage({ id: 'marketing.scene.n04.lbl03' }),
      ],
      imgUrl: require('@/assets/img/m3.jpg'),
      disabled:
        (creatList &&
          !creatList?.find((item) => item.type === 'BIRTHDAY_ACTIVITY')
            ?.created) ||
        !userAuths.includes('MENU_MARKETING_SCENE_BIRTHDAY'),
      oid: 'btn_marketing_activity_scene_marketing_list_create_birthday_marketing',
    },
    {
      id: 2,
      cardTitle: formatMessage({ id: 'marketing.scene.n04.lbl01' }),
      cardDesc: [
        formatMessage({ id: 'marketing.scene.n03.lbl02' }),
        formatMessage({ id: 'marketing.scene.n03.lbl03' }),
      ],
      imgUrl: require('@/assets/img/m4.jpg'),
      disabled:
        (creatList &&
          !creatList?.find((item) => item.type === 'MEMBER_ACTIVITY')
            ?.created) ||
        !userAuths.includes('MENU_MARKETING_SCENE_MEMBER'),
      oid: 'btn_marketing_activity_scene_marketing_list_create_member_day_marketing',
    },
    {
      id: 4,
      // 会员绑定
      cardTitle: formatMessage({ id: 'marketing.scene.n05.lbl01' }),
      cardDesc: [
        // formatMessage({ id: 'marketing.scene.n05.lbl02' }),
        // formatMessage({ id: 'marketing.scene.n05.lbl03' }),
        '提供绑定事件的会员关怀',
        '提高客户黏性',
      ],
      imgUrl: require('@/assets/img/m5.jpg'),
      disabled:
        (creatList &&
          !creatList?.find((item) => item.type === 'MEMBER_BINDING_ACTIVITY')
            ?.created) ||
        !userAuths.includes('MENU_MARKETING_SCENE_BIND'),
      oid: 'btn_marketing_activity_scene_marketing_list_create_member_binding',
    },
    {
      id: 5,
      // 会员消费
      cardTitle: formatMessage({ id: 'marketing.scene.n06.lbl01' }),
      cardDesc: [
        // formatMessage({ id: 'marketing.scene.n06.lbl02' }),
        // formatMessage({ id: 'marketing.scene.n06.lbl03' }),
        '提供消费事件的会员关怀',
        '提高客户黏性',
      ],
      imgUrl: require('@/assets/img/m6.jpg'),
      disabled:
        (creatList &&
          !creatList?.find((item) => item.type === 'CONSUMPTION_ACTIVITY')
            ?.created) ||
        !userAuths.includes('MENU_MARKETING_SCENE_CONSUMPTION'),
      oid: 'btn_marketing_activity_scene_marketing_list_create_member_consumption',
    },
    {
      id: 6,
      // 等级变更
      cardTitle: formatMessage({ id: 'marketing.scene.n07.lbl01' }),
      cardDesc: [
        // formatMessage({ id: 'marketing.scene.n07.lbl02' }),
        '提供等级变更事件的会员关怀',
        '提高客户黏性',
        // formatMessage({ id: 'marketing.scene.n07.lbl03' }),
      ],
      imgUrl: require('@/assets/img/m7.jpg'),
      disabled:
        (creatList &&
          !creatList?.find((item) => item.type === 'LEVEL_CHANGE_ACTIVITY')
            ?.created) ||
        !userAuths.includes('MENU_MARKETING_SCENE_LEVEL_CHANGE'),
      oid: 'btn_marketing_activity_scene_marketing_list_create_level_change',
    },
    {
      id: 7,
      // 积分使用
      cardTitle: formatMessage({ id: 'marketing.scene.n08.lbl01' }),
      cardDesc: [
        // formatMessage({ id: 'marketing.scene.n08.lbl02' }),
        '提供积分使用事件的会员关怀',
        '提高客户黏性',
        // formatMessage({ id: 'marketing.scene.n08.lbl03' }),
      ],
      imgUrl: require('@/assets/img/m8.jpg'),
      disabled:
        (creatList &&
          !creatList?.find((item) => item.type === 'POINT_USED_ACTIVITY')
            ?.created) ||
        !userAuths.includes('MENU_MARKETING_SCENE_POINT_USE'),
      oid: 'btn_marketing_activity_scene_marketing_list_create_points_use',
    },
    {
      id: 8,
      // 积分使用
      cardTitle: '电商渠道触达',
      cardDesc: [
        // formatMessage({ id: 'marketing.scene.n08.lbl02' }),
        '提供电商渠道多场景下的会员关怀',
        '提高客户黏性',
        // formatMessage({ id: 'marketing.scene.n08.lbl03' }),
      ],
      imgUrl: require('@/assets/img/m9.jpg'),
      disabled:
        (creatList &&
          !creatList?.find((item) => item.type === 'ECOMMERCE_ACTIVITY')
            ?.created) ||
        !userAuths.includes('MENU_MARKETING_SCENE_ECOMMERCE'),
    },
    {
      id: 9,
      // 积分使用
      cardTitle: '会员复购',
      cardDesc: ['提供等级变更事件的会员关怀', '提高客户黏性'],
      imgUrl: require('@/assets/img/m10.jpg'),
      disabled:
        (creatList &&
          !creatList?.find((item) => item.type === 'REPURCHASE_ACTIVITY')
            ?.created) ||
        !userAuths.includes('MENU_MARKETING_SCENE_MEMBER_REPURCHASE'),
    },
  ];

  // 查询事件处理
  const handleSearch = (newParam) => {
    setIsSearch(true);
    history.replace(
      `${pathname}?${qs.stringify({
        ...newParam,
        pageSize,
        pageNum: '1',
        time: timestamp,
      })}`,
    );
  };

  // 翻页事件处理
  const handlePageChange = (p) => {
    history.replace(
      `${pathname}?${qs.stringify({
        ...query,
        pageNum: p.pageNum,
        pageSize: p.pageSize,
      })}`,
    );
  };

  // 重置事件处理
  const handleRestClick = (rs) => {
    history.replace(
      `${pathname}?${qs.stringify({
        ...rs,
        pageSize: 10,
        pageNum: '1',
      })}`,
    );
  };

  // 获取列表
  const fetchData = useCallback(() => {
    const values = {
      title,
      status,
      type,
      pageNum,
      pageSize,
      time,
    };
    if (isSearch) {
      window.NE_DAWN.trigger(searchRef.current, {
        event: '_ec', // 事件名
        params: { ...values }, // 事件公参
      });
    }
    setIsSearch(false);
    dispatch({
      type: 'sceneMarketing/getSceneMarketingList',
      payload: {
        values,
      },
    });
  }, [dispatch, pageNum, pageSize, status, title, type, modification, time]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handleClick = (item) => {
    let toDetail = new Map([
      ['0', ['/marketing/scene/registration']],
      ['1', ['/marketing/scene/birthday']],
      ['2', ['/marketing/scene/member']],
      ['3', ['/marketing/scene/festival']],
      ['4', ['/marketing/scene/bind']],
      ['5', ['/marketing/scene/consumption']],
      ['6', ['/marketing/scene/level_change']],
      ['7', ['/marketing/scene/point_use']],
      ['8', ['/marketing/scene/ec_channels_reach']],
      ['9', ['/marketing/scene/repurchase']],
    ]);
    history.push({
      pathname: toDetail.get(`${item.id.toString()}`),
      query: {
        marketingId: item.id,
        sourceOid: item.oid,
      },
    });
  };

  const getMemberLevel = useCallback(() => {
    dispatch({
      type: 'sceneMarketing/getMemberLevel',
      payload: {},
    });
  }, [dispatch]);

  useEffect(() => {
    getMemberLevel();
  }, [getMemberLevel]);

  const sortNav = (list) => {
    const canArr = [];
    const disabledArr = [];
    list.forEach((item) => {
      if (item.disabled) {
        disabledArr.push(item);
      } else {
        canArr.push(item);
      }
    });
    return [...canArr, ...disabledArr];
  };
  return (
    <Box
      data-log={JSON.stringify({
        oid: 'page_marketing_activity_scene_marketing_list',
        isPage: true,
        params: {
          initUrl: window.location.origin + window.location.pathname,
        },
        events: ['_pv', '_pd'],
      })}
    >
      <CardListML cardList={sortNav(marketingData)} handleClick={handleClick} />
      <SearchCondition
        searchRef={searchRef}
        query={query}
        handleSearch={(par) => handleSearch(par)}
        restClick={handleRestClick}
      ></SearchCondition>
      <SceneMarketingResult
        modification={modification}
        setModification={setModification}
        setPageData={handlePageChange}
        pagination={{
          pageNum,
          pageSize,
        }}
      ></SceneMarketingResult>
    </Box>
  );
};
